import React from 'react';

/* MobX */
import { observer } from 'mobx-react-lite';

/* MUI */
import Typography from '@material-ui/core/Typography';
import { Grid, TextField } from '@material-ui/core';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Checkbox from '@material-ui/core/Checkbox';

/* Langan Components */
import FormInputTextField from '../../form-input/form-input-textfield.component';
import AreaInfo from './area-info/area-info.component';
import EsriMap from "../../map/EsriMap";
import SketchWidget from "../../map/SketchWidget";
import FeatureLayer from "../../map/FeatureLayer";
import { FileUploadButton } from '../../form-input/form-file-upload-button.component';

const ImpermeableAreaAppeal = observer((props) => {
  const { expanded,
    handleAccordianChange,
    statusReady, statusChange,
    statusImpermeable,
    impermeable,
    handleImpermeableChange,
    handleImpermeableAreaChange,
    setImperviousGraphics,
    imperviousFileName,
    imperviousFileChange,
    imperviousWarning,
    area,
    mapBlock,
    assessorBlock } = props;

  const { F_Appealed_Impermeable_Area,
    F_Appealed_Permeable_Area,
    F_Appealed_Billable_Impermeable_Area,
    F_Applicant_Comments_Impermeable
  } = impermeable;

  return (
    <Accordion expanded={expanded === 'panel2'} onChange={handleAccordianChange('panel2')}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} id="inaccurateImperviousAreaAppeal" style={{ backgroundColor: "whitesmoke" }} >
        <Typography variant="h6" gutterBottom color="primary" component='div'>
          <Checkbox
            checked={statusReady}
            disabled={statusChange}
            color="primary"
            inputProps={{ 'aria-label': 'secondary checkbox' }}
          />
          Enter Information for Inaccurate Impermeable Parcel Level Area
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          <Typography variant="body1" component='span'>
            The impermeable area appeal option is only available to standard rate (*) customers: <br />
            If there is an error in the amount of impermeable or permeable area assigned to your
            property. Impermeable area includes hard surfaces, such as rooftops, concrete,
            buildings, and pavement. Permeable area allows for some stormwater to soak into the
            ground and is charged a lower rate. Examples of permeable areas are grass, dirt, and
            gravel. <br />
            <Typography variant="body2">
              <i>
                (* This schedule shall apply to all non-residential parcels, mixed use parcels, property lots without wastewater service, residential parcels
                greater than 6,000 square feet of net parcel area and/or having more than 6 dwelling units, and/or any other parcels which do not meet the
                eligibility criteria.)
              </i>
            </Typography>
          </Typography>
          <Grid item xs={12}>
            {statusChange &&
              <Typography variant="h6" color="error">
                There is a current appeal pending. Please contact us at (415)-551-3000 before submitting a new request.
              </Typography>}
            <Typography variant="body1">
              Sketch on the map below to show area changes or populate the area field in the form below.
            </Typography>

            <EsriMap screenSize="sketch" itemId={process.env.REACT_APP_WEBMAP_ID} type="static">
              {statusImpermeable !== "submitted" &&
                <SketchWidget
                  handleAreaChange={handleImpermeableAreaChange}
                  handleGraphicsChange={setImperviousGraphics}
                  parcelId={mapBlock} />
              }
              <FeatureLayer parcelId={mapBlock} navigation={false} ></FeatureLayer>
            </EsriMap>

          </Grid>
          <Grid item xs={12}>
            <Typography variant="body1">
              The total impermeable area for which the Map Block Lot is being billed is incorrect. Impermeable area includes hard surfaces such as rooftops, concrete and paved parking areas.
            </Typography>
          </Grid>

          <AreaInfo
            mapBlock={mapBlock}
            assessorBlock={assessorBlock}
            area={area}
          />

          <FormInputTextField
            label="Appealed Impermeable Area"
            required={true}
            size={5}
            name="F_Appealed_Impermeable_Area"
            value={F_Appealed_Impermeable_Area}
            onChange={handleImpermeableChange}
            InputProps={{ readOnly: statusChange }}
          />

          <FormInputTextField
            label="Billable Appealed Impermeable Area"
            required={true}
            size={5}
            name="F_Appealed_Billable_Impermeable_Area"
            value={F_Appealed_Billable_Impermeable_Area}
            disabled
          />

          <FormInputTextField
            label="Appealed Permeable Area"
            required={true}
            size={5}
            name="F_Appealed_Permeable_Area"
            value={Math.round(F_Appealed_Permeable_Area)}
            disabled
          />

          {imperviousWarning &&
            <Grid item xs={12} align="left" >
              <Typography color="error">{imperviousWarning}</Typography>
            </Grid>}
          <Grid item xs={12} align="left">
            <FileUploadButton
              description={"Attach Relevant Documentation To Support Appeal"}
              fileChange={imperviousFileChange}
              disabled={statusChange} />
          </Grid>
          <Grid item xs={12} align="center">
            <TextField name="F_Applicant_Comments_Impermeable" variant="outlined" label="Applicant Comments" fullWidth
              value={F_Applicant_Comments_Impermeable} onChange={handleImpermeableChange} InputProps={{ readOnly: statusChange }} />
          </Grid>
        </Grid>
      </AccordionDetails>
    </Accordion>
  )
})

export default ImpermeableAreaAppeal;